module.exports = __webpack_public_path__ + "img/icon-user.3432ffd2.svg";